export default defineNuxtPlugin(async (nuxtApp) => {
  const route = useRoute();
  const headers = useRequestHeaders(["host"]);
  const host = process.client ? window.location.origin : headers.host;
  let labels = {};
  if (isEmpty(labels) && isValidLocale(route.params.locale)) {
    const { data } = await useFetch(
      `/api/pages/labels?lang=${route.params.locale}`,
      {
        headers: {
          host,
        },
      }
    );
    labels = { ...data.value };

    // transform every key into a getter
    Object.keys(labels).forEach((key) => {
      Object.defineProperty(labels, key, {
        value: labels[key],
        writable: false,
      });
    });
  }
  function isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }
  function isValidLocale(locale) {
    return /^it$|^en$|^en-us$|^fr$|^de$|^es$|^ko$|^ja$/.test(locale);
  }
  return {
    provide: {
      // return t as a getter
      get t() {
        return labels;
      },
    },
  };
});
